import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const WeightIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M21.8 5c-.1-.7-.4-.9-1.2-1.2A18.24 18.24 0 0 0 12 2a19.46 19.46 0 0 0-8.6 1.7c-.8.4-1.1.6-1.2 1.3A16.35 16.35 0 0 0 2 7.2v9.6C2 21.1 5.2 22 8 22h8c2.9 0 6-.9 6-5.2V7.2a16.35 16.35 0 0 0-.2-2.2ZM18 11.1c-.1 1-.9 1.2-2 1.2H8.1c-1.1 0-1.9-.2-2-1.2S5.6 8 5.4 6.6a36.79 36.79 0 0 1 5.8-.5v3.1a.8.8 0 0 0 1.6 0v-3a39.15 39.15 0 0 1 5.9.5c-.2 1.4-.6 3.4-.7 4.4Z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </IconBase>
  );
};

export default WeightIcon;
